/* @flow */

import * as React from 'react';
import ModalStatusContext from '../context/ModalStatusContext';

type Props = {
  children: React.Node,
};

export default function ModalStatusProvider({ children }: Props) {
  const [modals, setModals] = React.useState(new Set());

  const register = (id) => {
    setModals((set) => {
      const newSet = new Set(set);
      if (!newSet.has(id)) {
        newSet.add(id);
        return newSet;
      }
      return set;
    });
  };

  const unregister = (id) => {
    setModals((set) => {
      const newSet = new Set(set);
      if (newSet.has(id)) {
        newSet.delete(id);
        return newSet;
      }
      return set;
    });
  };

  return (
    <ModalStatusContext.Provider value={{ modals, register, unregister }}>
      {children}
    </ModalStatusContext.Provider>
  );
}
